module.exports = __webpack_public_path__ + "img/my-account-desktop-fr.fd9b80ee.jpg";